




























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import TabularHeader from '@/modules/shared/components/shared/TabularHeader.vue'
import { Prop } from 'vue-property-decorator'
import { ContentItemResourceType } from '@/modules/content-item/models/content-item-resource.model'
import ContentItemStatusView from '@/modules/content-item/components/shared/ContentItemStatusView.vue'
import {
  panelContentItemShowTabularColumns
} from '@/modules/content-item/models/columns/content-item-show-tabular.columns'
import { PanelContentCampaignRoute } from '@/modules/content-campaign/routes/panel-content-campaign.route'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'

@Component({
  components: { DateTooltipped, ContentItemStatusView, TabularHeader }
})
export default class PanelContentItemShowTabular extends Vue {
  constructor(
    private readonly routes: PanelContentCampaignRoute
  ) {
    super()
  }

  @Prop() contentItem!: ContentItemResourceType

  private get headerColumns() {
    return this.filterColumn
  }

  get filterColumn() {
    if (this.contentItem.data.completed_at)
      return panelContentItemShowTabularColumns(this.contentItem)
    return panelContentItemShowTabularColumns(this.contentItem)
      .filter(item => item.name !== 'completed_at')
  }

  get contentCampaignUrl() {
    return this.routes.show(this.contentItem.data.campaign.id)
  }
}
